export default {
    currentStep: state => state.currentStep,
    steps: state => state.steps,
    step: state => state.steps[state.currentStep-1].payload,
    firstStep: state => state.steps[0].payload,
    secondStep: state => state.steps[1].payload,
    thirdStep: state => state.steps[2].payload,
    fourthStep: state => state.steps[3].payload,
    fifthStep: state => state.steps[4].payload,
    sixthStep: state => state.steps[5].payload,
    countries: state => state.countries,
    specialistVideoUrl: sate => state.steps[2].payload.video_url,
    defaultCountry: state => state.defaultCountry,
}
